(() => {
  if (!document.body.classList.contains('dcom-textile-page')) return;

  const initialize = scope => {
    scope.querySelectorAll('.prd-block-info .block-accordion .tab-accordion-item').forEach(item => {
      const control = item.querySelector('input[type="checkbox"]');
      const trigger = item.querySelector('label');
      const content = item.querySelector('.tab-accordion-item-content');
      const inside = content?.querySelector('.tab-accordion-item-content-inside');
      if (!control || !trigger || !content || !inside || control.dataset.dcomAccordionReady) return;
      control.dataset.dcomAccordionReady = 'true';

      trigger.id = `dcom-accordion-trigger-${control.id}`;
      content.id = `dcom-accordion-content-${control.id}`;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-controls', content.id);
      trigger.querySelector('.toggle-arrow')?.setAttribute('aria-hidden', 'true');
      content.setAttribute('role', 'region');
      content.setAttribute('aria-labelledby', trigger.id);

      const syncHeight = () => {
        const height = `${inside.scrollHeight}px`;
        if (content.style.getPropertyValue('--tab-height') !== height) content.style.setProperty('--tab-height', height);
      };
      const syncState = () => {
        trigger.setAttribute('aria-expanded', String(control.checked));
        content.setAttribute('aria-hidden', String(!control.checked));
        content.inert = !control.checked;
        syncHeight();
      };
      control.addEventListener('change', syncState);
      trigger.addEventListener('keydown', event => {
        if (!['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        trigger.click();
      });
      new ResizeObserver(syncHeight).observe(inside);
      syncState();
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
